<app-toaster class="toaster" [config]="toastService.toaster"></app-toaster>
<filter-pane [filterComponents]="filterComponents" [showFilter]="showFilters"
  (change)="onFilterChange($event)" (submit)="applyFilters($event)"></filter-pane>
<div>
  <mat-toolbar class="toolbar-border">
    Redeem Rules
    <div class="pull-right is-flex" style="height: 35px;">
      <input type="text" class="filter-button filter-input-box" (change)="searchByShift()" [(ngModel)]="shiftSearch"
        placeholder="Search By Shift">
      <button mat-raised-button class="btn-primary" (click)="showFilters = !showFilters">Filters</button>
    </div>
  </mat-toolbar>
  <data-table [table]="table" (paginationChange)="fetchTableData()" (headerToSort)="sortByHeader($event)"></data-table>
</div>
